import api from '../../api/api_resource'
import axios from "axios/index";
import LaravelRouter from "../../thirdparty/Ziggy/route";

const state = {
};

// getters
const getters = {
};

// actions
const actions = {
    addFavourite({ commit, state }, bid_id) {
        return new Promise((success, reject) => {
            api.store('favourite-bids', {bid_id}).then(result => {
                success(true)
            }).catch(reject);
        });
    },
    removeFavourite({ commit, state }, bid_id) {
        return new Promise((success, reject) => {
            let route = LaravelRouter(`favourite-bids.destroy`, bid_id, true);
            axios.delete(route).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    reject(response);
                }
            }).catch(response => {
                reject(response);
            });
        });
    },
};

// mutations
const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/bidFavourites.js